<div class="rounded-2xl relative" style="width: 16px; height: 16px">
  <div
    class="rounded-xl mr-auto ml-auto my-1"
    style="width: 8px; height: 8px; background-color: lightgray"
  ></div>
</div>
